import { useTranslation } from 'react-i18next';
import { Box, Flex, Text } from '@chakra-ui/react';
import { FieldValues, useForm } from 'react-hook-form';
import Button from 'ui/molecules/Button';
import FormInputItem from 'ui/molecules/FormInputItem';
import { useMutation } from 'react-query';
import { useVendorConfig } from 'store/vendor/useVendorConfig';
import { checkPromoCode, PromoCodeResult } from 'api/checkPromoCode';

type Props = {
  onSuccess: (resp: PromoCodeResult) => void;
};

const PromoCodeForm = ({ onSuccess }: Props) => {
  const { t } = useTranslation();
  const { language } = useVendorConfig();
  const { register, handleSubmit, formState } = useForm();
  const { errors } = formState;

  const checkPromoCodeMutation = useMutation(checkPromoCode);
  const apiError = checkPromoCodeMutation.error;
  const isSubmitting = checkPromoCodeMutation.isLoading;

  const onSubmit = async (data: FieldValues) => {
    checkPromoCodeMutation.mutate(
      { language, code: data.promocode },
      {
        onSuccess: (res) => {
          onSuccess(res.data);
        },
      }
    );
  };

  return (
    <Box py={2} w="full">
      <Text fontSize="md" color="primaryColor" fontWeight="bold">
        {t('summary.promo.title')}
      </Text>

      <form
        style={
          isSubmitting
            ? {
                pointerEvents: 'none',
                opacity: '0.9',
                userSelect: 'none',
              }
            : {}
        }
        onSubmit={handleSubmit(onSubmit)}
      >
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align="center"
          w="full"
          gap={{ base: 3, md: 4 }}
        >
          <FormInputItem
            label=""
            errorMessage={errors.promocode?.message}
            {...register('promocode', {
              required: true,
              minLength: 3,
            })}
          />
          <Button
            type="submit"
            isLoading={isSubmitting}
            w={{ base: 'full', md: 'auto' }}
          >
            {t('summary.promo.submit')}
          </Button>
        </Flex>
      </form>

      {!isSubmitting && (errors.promocode || apiError) && (
        <Text color="reno.red" fontSize="sm">
          {t('summary.promo.invalid')}
        </Text>
      )}
    </Box>
  );
};

export default PromoCodeForm;
